import React, { useContext, useCallback } from 'react';
import moment from 'moment';
import styled, { css, keyframes } from 'styled-components';
import {
  Tooltip as BaseTooltip,
  ApproveIcon as BaseApproveIcon,
  ActiveDeclineIcon
} from '@ubeya/shared-web/components';
import { ago } from '@ubeya/shared/utils/time';
import { ReactComponent as BaseRefreshIcon } from '@ubeya/shared-web/assets/retry.svg';
import ConfigContext from '@ubeya/shared-web/contexts/ConfigContext';

const Wrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
`;

const Tooltip = styled(BaseTooltip)`
  margin-left: 20px;
  .rc-tooltip-inner {
    max-width: 200px;
    text-align: center;
  }
`;

const refreshAnimation = keyframes`
  100%{transform: rotate(360deg);}
`;

const RefreshIcon = styled(BaseRefreshIcon)`
  cursor: pointer;
  margin-left: 10px;
  ${({ $isLoading }) =>
    $isLoading &&
    css`
      animation: ${refreshAnimation} 1000ms infinite;
    `}
`;

const ApproveIcon = styled(BaseApproveIcon)`
  min-width: 26px;
`;

const ClientTimesheetResponseStatus = ({
  rowData: { clientApproved, clientDeclined, clientBranch, timesheetId, id: slotId, shiftId },
  columnData
}) => {
  const { setIsRefreshClientResponseOpen, allowResetStatus = false } = columnData || {};
  const { dateFormat, timeFormat } = useContext(ConfigContext);
  const { t } = useContext(ConfigContext);

  const onRefreshClick = useCallback(
    () => allowResetStatus && setIsRefreshClientResponseOpen?.({ slotId, shiftId, timesheetId }),
    [setIsRefreshClientResponseOpen, allowResetStatus, slotId, shiftId, timesheetId]
  );

  if (!clientApproved && !clientDeclined) {
    return <></>;
  }

  const { createdAt } = clientApproved || clientDeclined;

  const timeAgo = createdAt
    ? `${ago(createdAt, t)} (${moment(createdAt).format(dateFormat)} ${moment(createdAt).format(timeFormat)})`
    : '';

  const admin = clientBranch?.admins?.find(
    (branchAdmin) => branchAdmin.id === (clientApproved?.adminId || clientDeclined?.adminId)
  );

  const tooltip = `${admin?.firstName} ${admin?.lastName},${
    clientDeclined?.reason ? ` ${clientDeclined.reason},` : ''
  } ${timeAgo}`;

  return (
    <Wrapper>
      <Tooltip disabled={!admin} body={tooltip} trigger={['click', 'hover']}>
        {clientApproved ? <ApproveIcon $isActive /> : <ActiveDeclineIcon />}
      </Tooltip>
      {clientDeclined && allowResetStatus && (
        <Tooltip body={t('resetClientResponse')}>
          <RefreshIcon onClick={onRefreshClick} />
        </Tooltip>
      )}
    </Wrapper>
  );
};

export default ClientTimesheetResponseStatus;
